import { Button } from "primereact/button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from "primereact/dropdown";
import { Menu } from "primereact/menu";
import { Tooltip } from "primereact/tooltip";
import { classNames } from "primereact/utils";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router";
import { Avatar } from "primereact/avatar";
import { Badge } from "primereact/badge";
import PrimeConfirmDialog from "../../../components/dialog/PrimeConfirmDialog";
import PrimeDialog from "../../../components/dialog/PrimeDialog";
import { useEditableFlag } from "../../../hooks/useEditableFlag";
import { SystemLoading, checkLoading } from "../../../store/loadingStore";
import { MessageContext, handleSuccessMessage } from "../../../store/messageStore";
import {
  DeleteActivityData,
  getCompanyPlaceList,
  getPlanOrganizationalBoundaryList,
  queryActivityClassList,
  getApproveWorkFlowList,
  settingApproveWorkFlow,
  approveWork,
} from "../../../utility/service/carbon-service";
import { checkDpSuccess } from "../../../utility/service/tool-service";
import ActivityTable from "./ActivityTable";
import { AcctContext } from "../../../utility/useReduce/userNameReduce";

const ActivityData = () => {
  const apiList = [
    {
      classSeq: "001",
      classNo: "1",
      className: "範疇1:直接排放 ",
      emissionList: [
        {
          identifySeq: "",
          typeSeq: "",
          typeName: "固定燃燒源",
          processSeq: "",
          deviceSeq: "1",
          deviceName: "柴油發電機",
          sourceSeq: "",
          sourceName: "柴油",
          quantity: "2",
          isCalculate: "Y",
          remark: "",
          devicePicPath: "",
          fileExtension: "",
          sort: "1",
          displayStatus: "1",
        },
        {
          identifySeq: "",
          typeSeq: "",
          typeName: "移動燃燒源",
          processSeq: "",
          deviceSeq: "2",
          deviceName: "運輸作業車輛",
          sourceSeq: "",
          sourceName: "汽油",
          quantity: "1",
          isCalculate: "Y",
          remark: "",
          devicePicPath: "",
          fileExtension: "",
          sort: "2",
          displayStatus: "0",
        },
        {
          identifySeq: "",
          typeSeq: "",
          typeName: "移動燃燒源",
          processSeq: "",
          deviceSeq: "3",
          deviceName: "冰水機",
          sourceSeq: "",
          sourceName: "R-410A，HFC-32/HFC-125 (50.0/50.0)",
          quantity: "1",
          isCalculate: "Y",
          remark: "",
          devicePicPath: "",
          fileExtension: "",
          sort: "3",
          displayStatus: "0",
        },
        {
          identifySeq: "",
          typeSeq: "",
          typeName: "逸散：滅火器",
          processSeq: "",
          deviceSeq: "4",
          deviceName: "消防設施",
          sourceSeq: "",
          sourceName: "CO2",
          quantity: "10",
          isCalculate: "Y",
          remark: "CO2滅火器",
          devicePicPath: "",
          fileExtension: "",
          sort: "4",
          displayStatus: "0",
        },
      ],
    },
    {
      classSeq: "002",
      classNo: "2",
      className: "範疇2:能源間接排放",
      emissionList: [
        {
          identifySeq: "",
          typeSeq: "",
          typeName: "外購電力",
          processSeq: "",
          deviceSeq: "",
          deviceName: "空壓機",
          sourceSeq: "",
          sourceName: "電力",
          quantity: "1",
          isCalculate: "Y",
          remark: "",
          devicePicPath: "",
          fileExtension: "",
          sort: "1",
          displayStatus: "1",
        },
        {
          identifySeq: "",
          typeSeq: "",
          typeName: "外購電力",
          processSeq: "",
          deviceSeq: "",
          deviceName: "空壓機02",
          sourceSeq: "",
          sourceName: "電力",
          quantity: "1",
          isCalculate: "Y",
          remark: "",
          devicePicPath: "",
          fileExtension: "",
          sort: "2",
          displayStatus: "0",
        },
      ],
    },
  ];
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [places, setPlaces] = useState(null);
  const { itemObj, setAction, action, setItemObj } = useOutletContext();
  const [, loading] = useContext(SystemLoading);
  const [state, dispatchUser] = useContext(AcctContext); //訊息視窗
  const [, dispatch] = useContext(MessageContext); //訊息視窗
  const [delDialog, setDelDialog] = useState(false);
  const isEditable = useEditableFlag("F10103");
  const [approverList, setApproverList] = useState([]);

  // 批次刪除
  const menu = useRef(null);
  const [batchAction, setBatchAction] = useState("");
  const [selectValue, setSelectValue] = useState({});
  const [batchDelPopup, setBatchDelPopup] = useState(false);
  const [batchApproveDialog, setBatchApproveDialog] = useState(false);
  const [approveFlowList, setApproveFlowList] = useState([]);
  const [batchApproveStatus, setBatchApproveStatus] = useState("D");
  const [companyPlaceList, setCompanyPlaceList] = useState([]);
  // 簽核標記
  const [approveFlag, setApproveFlag] = useState(false);
  const [isCompany, setIsCompany] = useState(false);
  const isAdmin = state?.isAdmin === "Y";

  useEffect(() => {
    axios_getPlanOrganizationalBoundaryList();
    //活動數據查詢
    axios_queryActivityClassList();
    axios_getApproveWorkFlowList();
  }, []);

  // 查詢審核流程選項
  const axios_getApproveWorkFlowList = () => {
    getApproveWorkFlowList().then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.approverList;
        setApproverList(data);
      }
    });
  };

  // 組織邊界場所
  const axios_getPlanOrganizationalBoundaryList = () => {
    getPlanOrganizationalBoundaryList({ planSn: itemObj?.planSn }).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.planList;

        // 找尋場所名稱
        getCompanyPlaceList().then((res) => {
          if (checkDpSuccess(res)) {
            let companyList = res.data.RespBody.companyPlaceList?.filter((item) => item.companySeq === itemObj?.companySeq)[0];
            setIsCompany(companyList?.companySeq === state?.companySeq);
            const placeMap = new Map();
            companyList?.placeList?.forEach((item) => {
              placeMap.set(item.placeSeq, item.placeName);
            });
            data.forEach((plan) => {
              plan.placeName = placeMap.get(plan.placeSeq) || null;
            });
          }
        });

        setCompanyPlaceList(data);
      }
    });
  };

  const getClassByCriterion = (criterion) => {
    if (criterion === "0") return "S";
    if (criterion === "9") return "G";
    return "C";
  };

  const axios_queryActivityClassList = (
    reqBody = {
      planSn: itemObj?.planSn,
      class: getClassByCriterion(itemObj?.criterion),
    },
  ) => {
    checkLoading(loading);
    queryActivityClassList(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          setApproveFlag(res?.data?.RespBody?.approveFlag);
          setData(res?.data.RespBody?.classList);
          setPlaces(res?.data?.RespBody.places);
        }
      })
      .finally(() => checkLoading(loading, false));
  };

  const confirmDel = () => {
    DeleteActivityData({
      identifySeq: [itemObj?.data?.identifySeq],
    })
      .then((res) => {
        if (checkDpSuccess(res)) {
          handleSuccessMessage(dispatch, t("button.deleteData") + " " + t("message.success"));
          axios_queryActivityClassList();
        }
      })
      .finally(() => {
        setDelDialog(false);
        checkLoading(loading, false);
      });
  };

  const {
    register,
    handleSubmit,
    watch,
    clearErrors,
    getValues,
    setValue,
    resetField,
    reset: resetForm,
    control,
    reset,
    formState: { errors, isValid, isDirty },
  } = useForm({
    defaultValues: {
      role: "",
    },
    //錯誤驗證時機
    mode: "all",
  });

  if (!data.length) {
    return <></>;
  }

  const items = [
    {
      label: `${t("button.batch")}${t("button.delete")}`,
      icon: "pi pi-trash",
      disabled: !isEditable,
      command: () => {
        setBatchAction("delete");
      },
    },
    ...(approveFlag
      ? [
          {
            label: `${t("button.batch")}${t("button.approveSetting")}`,
            icon: "pi pi-users",
            disabled: !isCompany,
            command: () => {
              setBatchAction("approve");
              setBatchApproveStatus("D");
            },
          },
        ]
      : []),
  ];

  const batcActionConent = () => {
    switch (batchAction) {
      case "delete":
        return <span className="font-bold">{`${t("button.batch")}${t("button.delete")}`}</span>;
      case "approve":
        return (
          <span className="font-bold">
            {batchApproveStatus === "RTA"
              ? `${t("button.batch")}${t("button.reApply")}`
              : `${t("button.batch")}${t("button.approveSetting")}`}
          </span>
        );
      default:
        return null;
    }
  };

  // 處理刪除
  const handleDataDel = (classNo, newData) => {
    setSelectValue((prev) => ({
      ...prev,
      [classNo]: newData,
    }));
  };

  const batchDelete = () => {
    checkLoading(loading);
    const sortResult = Object.entries(selectValue)
      .filter(([classNo, data]) => data?.length > 0) // 空陣列跳過
      .flatMap(([classNo, data]) => data.map((item) => item.identifySeq));
    DeleteActivityData({
      identifySeq: sortResult,
    })
      .then((res) => {
        if (checkDpSuccess(res)) {
          handleSuccessMessage(dispatch, t("button.deleteData") + " " + t("message.success"));
          axios_queryActivityClassList();
        }
      })
      .finally(() => {
        setBatchAction("");
        setSelectValue({});
        setBatchDelPopup(false);
        checkLoading(loading, false);
      });
  };

  const getBatchIdentifySeqList = () => {
    const identifySeqList = Object.values(selectValue)
      .flatMap((list) => list || [])
      .map((item) => item?.identifySeq)
      .filter((item) => !!item);
    return [...new Set(identifySeqList)];
  };

  const getBatchSelectedCount = () => {
    return Object.values(selectValue).reduce((sum, list) => sum + (list?.length || 0), 0);
  };

  const batchReturnedApprove = async () => {
    checkLoading(loading);
    try {
      const identifySeqList = getBatchIdentifySeqList();
      const resultList = await Promise.all(identifySeqList.map((identifySeq) => approveWork({ identifySeq, action: "C", memo: "" })));
      const isAllSuccess = resultList.every((res) => checkDpSuccess(res));
      if (isAllSuccess) {
        handleSuccessMessage(dispatch, t("button.reApply") + " " + t("message.success"));
        axios_queryActivityClassList();
        setBatchAction("");
        setSelectValue({});
      }
    } finally {
      checkLoading(loading, false);
    }
  };

  // 審核流程設定
  const axios_settingApproveWorkFlow = (reqBody, callback) => {
    checkLoading(loading);
    settingApproveWorkFlow(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          handleSuccessMessage(dispatch, t("button.setting") + " " + t("message.success"));
          axios_queryActivityClassList();
          if (callback) {
            callback();
          }
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  const flowPreviewTemplate = () => {
    return (
      <div className="p-card bg-gray mt-2">
        <div className="p-card-body">
          <div className="flex justify-content-center">
            {approveFlowList.map((group, index) => {
              const useList = group?.userList;
              const firstUser = useList?.[0];
              const count = useList?.length ?? 0;
              const tooltipId = `batch-approve-tt-${index}`;
              const isLast = index === approveFlowList.length - 1;
              return (
                <div key={index} className="flex align-items-center">
                  <div className="flex flex-column align-items-center">
                    <Avatar
                      label={firstUser?.userName?.[0] ?? "U"}
                      shape="circle"
                      className={`p-overlay-badge tooltip-${tooltipId}`}
                      data-pr-position="bottom"
                      data-pr-tooltip={`${group?.model ? t(`approveModelOption.${group?.model}`) : ""}\n${useList
                        .map((u) => u.userName)
                        .join("\n")}`}
                    >
                      {count > 1 && <Badge value={count} severity="danger" />}
                    </Avatar>
                    <Tooltip target={`.tooltip-${tooltipId}`} />
                  </div>

                  {!isLast && (
                    <div className="flex align-items-center px-3">
                      <div className="w-4rem border-top-2 border-gray-300" />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div
        className="flex gap-2 align-items-center justify-content-center w-full"
        style={{ transform: "translateY(-1rem)" }}
      >
        {batcActionConent()}

        {batchAction === "" && (
          <>
            <div className="w-full">
              <Controller
                name={`queryPlanPlaceSeq`}
                control={control}
                render={({ field, fieldState }) => (
                  <Dropdown
                    showClear
                    optionLabel="placeName"
                    optionValue="planPlaceSeq"
                    value={field.value}
                    options={companyPlaceList}
                    placeholder={t("plz_chs_all")}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(e) => {
                      field.onChange(e.value);
                      setValue("planPlaceSeq", e.value);
                      axios_queryActivityClassList({
                        planSn: itemObj?.planSn,
                        class: itemObj?.criterion === "0" ? "S" : "C",
                        planPlaceSeq: e.value,
                      });
                    }}
                  />
                )}
              />
            </div>
            <div className="ml-auto">
              <Menu model={items} popup ref={menu} />
              <Button
                className="p-button-icon-only"
                onClick={(event) => menu.current.toggle(event)}
                icon="pi pi-ellipsis-h"
                aria-controls="popup_menu"
                rounded
                text
                aria-haspopup
              />
            </div>
          </>
        )}

        {batchAction === "approve" && (
          <div className="flex-shrink-0">
            <Dropdown
              optionLabel="label"
              optionValue="value"
              value={batchApproveStatus}
              options={[
                { label: t("approve.D"), value: "D" },
                { label: t("approve.RTA"), value: "RTA" },
              ]}
              placeholder={t("plz_chs")}
              className="w-8rem"
              onChange={(e) => {
                setBatchApproveStatus(e.value);
                setSelectValue({});
              }}
            />
          </div>
        )}

        {batchAction !== "" && (
          <div className="ml-auto">
            {/* 刪除 */}
            {batchAction === "delete" && (
              <Button
                disabled={getBatchSelectedCount() === 0}
                className="p-button-icon-only"
                icon="pi pi-trash"
                onClick={() => {
                  setBatchDelPopup(true);
                }}
                tooltip={t("button.deleteData")}
                tooltipOptions={{ position: "top" }}
                type="button"
                size="small"
                severity="danger"
                rounded
                text
              />
            )}
            {batchAction === "approve" && (
              <Button
                disabled={
                  getBatchSelectedCount() === 0 || (batchApproveStatus === "D" && approverList?.length === 0)
                }
                className="p-button-icon-only"
                onClick={() => {
                  if (batchApproveStatus === "RTA") {
                    batchReturnedApprove();
                  } else {
                    setBatchApproveDialog(true);
                  }
                }}
                tooltip={batchApproveStatus === "RTA" ? t("button.reApply") : t("button.approveSetting")}
                tooltipOptions={{ position: "top" }}
                type="button"
                size="small"
                rounded
                text
              >
                {batchApproveStatus === "RTA" ? (
                  <FontAwesomeIcon icon="fa-solid fa-paper-plane" />
                ) : (
                  <FontAwesomeIcon icon="fa-solid fa-users-gear" />
                )}
              </Button>
            )}
            {/* 取消 */}
            <Button
              className="p-button-icon-only"
              icon="pi pi-times"
              onClick={() => {
                setBatchAction("");
                setSelectValue({});
                setBatchApproveStatus("D");
                setBatchApproveDialog(false);
                setApproveFlowList([]);
              }}
              tooltip={t("button.cancel")}
              tooltipOptions={{ position: "top" }}
              type="button"
              rounded
              text
              size="small"
            />
          </div>
        )}
      </div>

      <div className="flex flex-column gap-3">
        {data?.map((e, index) => {
          return (
            <React.Fragment key={e?.classSeq || index}>
              {e?.emissionList?.length > 0 && (
                <div>
                  <ActivityTable
                    header={e?.displayClassName}
                    data={e?.emissionList}
                    setItemObj={setItemObj}
                    classNoInfo={e}
                    places={places}
                    setDelDialog={setDelDialog}
                    batchAction={batchAction}
                    batchApproveStatus={batchApproveStatus}
                    selectValue={selectValue}
                    setSelectValue={setSelectValue}
                    dataDel={(rowData) => handleDataDel(e.displayClassNo, rowData)}
                    approverList={approverList}
                    handleSettingApproveWorkFlow={axios_settingApproveWorkFlow}
                    approveFlag={approveFlag}
                    isCompany={isCompany}
                    reQuery={axios_queryActivityClassList}
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
      {/* 刪除 */}
      <PrimeConfirmDialog
        visible={delDialog}
        onClose={() => {
          setDelDialog(false);
        }}
        onConfirm={() => {
          confirmDel();
        }}
        title={t("button.deleteData")}
        bodyTemplate={t("cfm_clear_activeData")}
      />

      {/* 批次刪除 */}
      <PrimeDialog
        visible={batchDelPopup}
        isShowConfBtn={false}
        isShowDelBtn={true}
        onDelete={() => {
          batchDelete();
        }}
        onClose={() => {
          setBatchDelPopup(false);
        }}
        title={`${t("button.batch")}${t("button.deleteData")}`}
        bodyTemplate={<>{t("batchDeleteDataContent")}</>}
      />

      {/* 批次簽核設定 */}
      <PrimeDialog
        visible={batchApproveDialog}
        onClose={() => {
          setBatchApproveDialog(false);
          setApproveFlowList([]);
        }}
        onConfirm={() => {
          axios_settingApproveWorkFlow(
            {
              approveFlowList,
              identifySeqList: getBatchIdentifySeqList(),
            },
            () => {
              setBatchApproveDialog(false);
              setApproveFlowList([]);
              setBatchAction("");
              setSelectValue({});
            },
          );
        }}
        disabledConfirm={approveFlowList?.length === 0 || getBatchSelectedCount() === 0}
        title={t("button.approveSetting")}
        bodyTemplate={
          <div className="w-full">
            <label className="form-label">{t("approverWorkFlow")}</label>
            <Dropdown
              optionLabel="label"
              optionValue="workFlowList"
              value={approveFlowList}
              options={approverList}
              placeholder={t("plz_chs")}
              className="w-full"
              onChange={(e) => {
                setApproveFlowList(e.value);
              }}
            />
            {approveFlowList?.length > 0 && flowPreviewTemplate()}
          </div>
        }
      />
    </>
  );
};

export default ActivityData;
